import { ActionIcon, Group, Stack, Text, Tooltip } from '@mantine/core'
import { IconCheck, IconTrash } from '@tabler/icons-react'
import { memo, useCallback } from 'react'

import { theme } from '@/configs/theme'
import type { FAQItem } from '@/types/faq'

interface PendingFAQEntryProps {
  faq: FAQItem
  onApprove: (id: string) => void
  onReject: (id: string) => void
}

export const PendingFAQEntry = memo<PendingFAQEntryProps>(function PendingFAQEntry({ faq, onApprove, onReject }) {
  const handleApprove = useCallback(() => {
    onApprove(faq.id)
  }, [faq.id, onApprove])

  const handleReject = useCallback(() => {
    onReject(faq.id)
  }, [faq.id, onReject])

  return (
    <Stack
      gap="xs"
      p="md"
      style={{
        border: '1px solid var(--mantine-color-gray-3)',
        borderRadius: '8px',
        backgroundImage: `linear-gradient(120deg, ${theme.alpha(theme.colors.primaryColors[6], 0.15)} 0%, ${theme.alpha(theme.colors.cyan[4], 0.1)} 100%)`,
        borderColor: theme.colors.primaryColors[6],
      }}>
      <Group justify="space-between" align="flex-start">
        <Stack gap="xs" style={{ flex: 1 }}>
          <Text
            size="sm"
            fw={500}
            style={{
              color: theme.colors.primaryColors[8],
            }}>
            {faq.question}
          </Text>
          <Text
            size="sm"
            style={{
              color: theme.colors.primaryColors[7],
            }}>
            {faq.answer}
          </Text>
        </Stack>

        <Group gap="xs" align="flex-start">
          <Tooltip label="Approve">
            <ActionIcon variant="gradient" size="sm" onClick={handleApprove}>
              <IconCheck size={14} />
            </ActionIcon>
          </Tooltip>

          <Tooltip label="Discard">
            <ActionIcon variant="subtle" color="red" size="sm" onClick={handleReject}>
              <IconTrash size={16} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Group>
    </Stack>
  )
})
